import React, { Component } from "react";
import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scrolltoTop";
import { artistsdata } from "../data/artistdata";
import Header from "../constants/header";
import TacForm from "../components/form";

export default class ArtistsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        email: "",
        message: "",
      },
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  componentDidMount() {
    this.scrollToHash();
    window.addEventListener("popstate", this.scrollToHash, false);
  }
  componentWillUnmount() {
    window.removeEventListener("popstate", this.scrollToHash, false);
  }

  scrollToHash = () => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  };

  render() {
    const { formData } = this.state;
    const fields = [
      {
        name: "name",
        label: "Name",
        type: "text",
        required: true,
        autoComplete: "name",
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        required: true,
        autoComplete: "email",
      },
      {
        name: "message",
        label: "Message",
        type: "textarea",
        required: true,
        autoComplete: "message",
      },
    ];

    return (
      <>
        <div className="artist-page-container">
          <Header />
          <div className="artists-hero" id="hero"></div>
          <div id="artistlist" className="artist-list-wrapper">
            <img
              className="leaves"
              src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/bigLeaves.webp"
              alt=""
            />
            <h3>Meet the Artists</h3>
            <div className="artist-list">
              {artistsdata.map((artist) => (
                <Link
                  to={`/artists/${artist.web}`}
                  key={artist.web}
                  className="artist"
                  onClick={scrollToTop}
                >
                  <div className="opt">
                    <div className="artisthover">
                      <p>
                        Find out more about <br /> {artist.name}
                      </p>
                    </div>
                    <img src={artist.image} alt={artist.name} />
                    <p className="artist-name">{artist.name}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <section className="artists-form-section form">
            <TacForm
              fields={fields}
              formid="Artist"
              first="Join The AfroCollective today"
              second="Are you interested in joining a collective of artists that work together to keep Afrofusion alive and thriving?"
              third="Fill out the form for a chance to join us!"
              formData={formData}
              onChange={this.handleChange}
            />
            <div className="form-img-container">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/artists_page/form.webp"
                className="form-img"
                alt="artists-form-img"
              />
            </div>
          </section>
        </div>
      </>
    );
  }
}
